import { css } from 'styled-components';
export const animatedHeight = {
    contentWrapper: () => css `
    box-sizing: border-box;
    width: 100%;
    position: relative;
    z-index: 1;
  `,
    nextContentWrapper: () => css `
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    z-index: -1;
    opacity: 0;
  `,
};
